// Core Imports
import * as React from 'react';
import { canViewInvoices } from 'src/utils/permissions';

// Style, Media and  Misc imports
import './EmptyInvoices.scss';
import emptyInvoiceImage from 'src/assets/emptyInvoicesImage';
import Loader from 'src/components/common/Loader';

const EmptyInvoices = (props: any) => {
  const { t } = props;
  switch (props.type) {
    case 'loading':
      return (
        <div className="rp-empty-invoices">
          <Loader />
        </div>
      );
    default:
    case 'noResults':
      return (
        <div className="rp-empty-invoices">
          <img src={emptyInvoiceImage} alt="" />
          <h1>
            {canViewInvoices()
              ? t('invoices.emptyInvoices')
              : "You don't have access to see invoices."}
          </h1>
          <p>{t('invoices.appreciateBusiness')}</p>
        </div>
      );
    case 'noSearch':
      return (
        <div className="rp-empty-invoices">
          <img src={emptyInvoiceImage} alt="" />
          <h1>{t('common.noResultsFound')}</h1>
          <p>{t('invoices.noInvoicesTryAgain')}</p>
        </div>
      );
  }
};

export default EmptyInvoices;
